import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'huge-monorepo-teltonika-confirm-upload-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-confirm-upload-modal.component.html',
  styleUrl: './teltonika-confirm-upload-modal.component.scss',
})
export class TeltonikaConfirmUploadModalComponent {
  fileName: string;

  constructor(
    public dialogRef: MatDialogRef<TeltonikaConfirmUploadModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fileName: string }
  ) {
    this.fileName = data.fileName;
  }

  closeDialog(confirm: boolean): void {
    this.dialogRef.close(confirm);
  }

}
